export const AUDIO_PRECACHE_NAME = 'audio';
export const TILES_PRECACHE_NAME = 'mapbox-tiles';
export const MAPBOX_PRECACHE_NAME = 'mapbox-general';
export const VIDEO_PRECACHE_NAME = 'video';
export const IMAGES_PRECACHE_NAME = 'images';
